module.exports = __webpack_public_path__ + "img/59.53879827.jpg";